/*
 *   File : text-area.js
 *   Author : https://evoqins.com
 *   Description : Text area component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React, { memo } from "react";
import "../../Style/Components/input.scss";
import { formatInputErrorMessage } from "../../Utils/format-input-error";
const CustomTextArea = (props) => {
  const _handleChange = (e) => {
    props.handleChange(e.target.value);
  };

  return (
    <div className="e-textarea-wrap">
      {props.label && (
        <label
          className={
            props.labelStyle ? props.labelStyle : "text-black   fw-500  fs-14 "
          }
        >
          {props.label}
          {props.require && <span className="text-cg-red">*</span>}
        </label>
      )}

      <div className="pt-2">
        <textarea
          id={props.id}
          value={props.value}
          style={{ resize: "none" }}
          autoFocus={props.autoFocus}
          className={`${props.error ? "e-border-error" : "e-border-input"}
          ${props.className} e-textarea rounded-8 fs-14`}
          placeholder={props.placeholder}
          required={props.required}
          rows={props.rows || 6}
          readOnly={props.readOnly}
          cols={props.cols}
          onChange={_handleChange}
        />
      </div>
      {props.error && (
        <p className="mb-0 fs-12 text-cg-red">
          {formatInputErrorMessage(props.error)}
        </p>
      )}
    </div>
  );
};

CustomTextArea.defaultProps = {
  handleChange: () => {},
  className: "",
  error: "",
};

export default memo(CustomTextArea);
